module.exports = __webpack_public_path__ + "static/media/logo.e8764834.png";